import { ServicePage } from './ServicePage';
import { Layers } from 'lucide-react';

const AggregatorPage = () => {
  return <ServicePage serviceKey="aggregator" icon={Layers} />;
};

export default AggregatorPage;
